<template>
    <b-modal
        size="lg"
        v-model="mostrarModal"
        no-close-on-backdrop
        @close="fecharModal()"
        @show="preencher()">
        <div slot="modal-title">
            Ação - Plano de Trabalho -
            <b-badge variant="warning">{{ operacao }}</b-badge>
        </div>
        <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
        <b-row>
            <b-col sm="12" md="12">
                <b-form-group>
                    <label for="Descricao">Nome da Ação</label>
                    <b-input-group>
                        <b-form-input
                            type="text"
                            v-model="nomeAcao"
                        ></b-form-input>
                        <b-form-invalid-feedback> O nome é Obrigatório </b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="6" md="6">
                <b-form-group>
                    <label for="codGestor">Gestor de Execução</label>
                    <b-input-group>
                        <b-form-select
                            v-model="codGestor"
                            type="text"
                            :options="gestores"
                            value-field="codFuncionario"
                            text-field="nome"
                            >
                        </b-form-select>
                        <b-form-invalid-feedback>Gestor é obrigatório</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="6" md="6">
                <b-form-group>
                    <label for="codUnidade">Unidade</label>
                    <b-input-group>
                        <b-form-select
                            id="codUnidade"
                            v-model="codUnidade"
                            type="text"
                            :options="unidades"
                            value-field="codUnidade"
                            text-field="nome"
                            
                        ></b-form-select>
                        <b-form-invalid-feedback>Unidade é obrigatório</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <div slot="modal-footer">
            <b-button variant="secondary" @click.stop="fecharModal()">
                Cancelar
            </b-button>
            <b-button
                variant="primary"
                :disabled="this.$v.$invalid"
                @click.stop="salvar()"
                class="ml-1">
                Salvar
            </b-button>
        </div>
    </b-modal>
</template>

<script>

import { required } from 'vuelidate/lib/validators'

export default {
    props: {
        convenio: Object,
        acao: Object,
        operacaoProp: String,
        mostrarModal: {
            type: Boolean,
            default: () => false
        },
        erros: {
            type: Array,
            default: () => []
        },
        dataServicos: {
            type: Object
        },
    },

    validations: {
        nomeAcao: {
            required
        },
        codUnidade: {
            required
        },
        codGestor: {
            required
        }
    },

    data() {
        return {
            nomeAcao: null,
            codGestor: null,
            codUnidade:null,
            idAcaoPlanoTrabalho: null,
            codSituacao: null,
            emailGestor: null,
            nomeGestor: null,
            nomeUnidade: null,
            gestores: [],
            unidades: [],
        }
    },

    computed: {
        operacao() {
            if (this.operacaoProp == 'I') {
                return 'INCLUSÃO'
            }
            return 'ATUALIZAÇÃO'
        }
    },

    methods: {
        preencher() {
            this.obterGestores()
            this.obterUnidades()
            if (this.operacaoProp == 'A') {
                this.nomeAcao = this.acao.nomeAcao
                this.codGestor = this.acao.codGestor
                this.codUnidade = this.acao.vcCodUnidade
                this.idAcaoPlanoTrabalho = this.acao.idAcaoPlanoTrabalho
                this.codSituacao = this.acao.codSituacao
                this.emailGestor = this.acao.emailGestor
                this.nomeGestor = this.acao.nomeGestor
                this.nomeUnidade = this.acao.nomeUnidade
            }
        },

        fecharModal() {
            this.$emit('fechar')
            this.resetar()
        },

        resetar(){
            this.nomeAcao = null
            this.codGestor = null
            this.codUnidade = null
        },

        obterGestores(){
            this.$store.dispatch('addRequest')
            this.dataServicos.obterGestores().then(
                response => {
                        if (response) {
                            if (response.success) {
                                this.gestores = response.data
                            } else {
                                this.erros = response.errors
                            }
                        }
                        this.$store.dispatch('removeRequest')
                    }
            )
        },

        obterUnidades(){
            this.$store.dispatch('addRequest')
            this.dataServicos.obterUnidades().then(
                response => {
                        if (response) {
                            if (response.success) {
                                this.unidades = response.data
                            } else {
                                this.erros = response.errors
                            }
                        }
                        this.$store.dispatch('removeRequest')
                    }
            )
        },

        salvar() {
            let acaoDto = {
                idConvenio : this.convenio.idConvenio,
                nomeAcao: this.nomeAcao,
                codGestor: this.codGestor,
                VcCodUnidade: this.codUnidade,
                idAcaoPlanoTrabalho: this.idAcaoPlanoTrabalho,
                codSituacao: this.codSituacao,
                emailGestor: this.emailGestor,
                nomeGestor: this.nomeGestor,
                nomeUnidade: this.nomeUnidade,
            }
            this.$emit('salvar', acaoDto)
            this.resetar()
        },
    },
}
</script>
